import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Box,
  TablePagination,
} from "@mui/material";
import DetailsModal from "./DetailsModal";
import { getSubscriptions_req } from "../api/all.api";

function SubscriptionTable({
  openFilter,
  frequency,
  state,
  subscriptionBtn,
  setSubscriptionBtn,
  sku,
}) {
  const [selectedSub, setSelectedSub] = useState(null);
  const [data, setData] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const getSubscription = async () => {
    const response = await getSubscriptions_req(frequency, state, sku);

    setData(response?.data);
    setSubscriptionBtn(false);
  };

  useEffect(() => {
    getSubscription();
  }, [subscriptionBtn]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedData = data?.subscriptions?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  return (
    <Box>
      <Box
        display="flex"
        justifyContent="flex-end"
        mb={2}
      >
        <Button
          onClick={openFilter}
          variant="outlined"
        >
          Modify Filter
        </Button>
      </Box>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>SKU</TableCell>
            <TableCell>Subscription ID</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {paginatedData?.map((sub) => (
            <TableRow key={sub.id}>
              <TableCell>{sub?.attributes?.sku}</TableCell>
              <TableCell>{sub?.id}</TableCell>
              <TableCell>{sub?.attributes?.state}</TableCell>
              <TableCell>
                <Button
                  size="small"
                  onClick={() => setSelectedSub(sub)}
                >
                  View
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={data?.subscriptions?.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25, 50]}
      />
      <DetailsModal
        open={Boolean(selectedSub)}
        onClose={() => setSelectedSub(null)}
        data={selectedSub}
        type="Subscription"
      />
    </Box>
  );
}

export default SubscriptionTable;
